module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_menu_4_rec_fondo_motivo_2.77a9f03f.png";